import React from 'react';
import { Grid, Box, Card, CardContent } from "@mui/material";
import { ComTypography } from '../commonFields/ComTypography';
import useMediaQuery from '@mui/material/useMediaQuery';
import "./../about/Aboutus.css";
import explore from "./../images/expolre.jpg";
import "./Style.css";
import MicrosoftCycle from './MicrosoftCycle';
import Client from './Client';
import ControlCost from './ControlCost';
import CrmApp from './CrmApp';
import ErpApp from './ErpApp';
import CrmErp from './CrmErp';
import HelptoTalk from './HelptoTalk';


const Explore = () => {
  const vMediaQuery = useMediaQuery('(max-width:600px)');

  const ExploreStyle = {
    display: "flex",
    margin: 'auto',
    padding: vMediaQuery ? "0px" : "16px",
    backgroundColor: "#f2fcf5",
    border: "1px solid green",
    boxShadow: vMediaQuery ? "8px 8px rgba(165, 181, 169, 0.6)" : "16px 16px rgba(165, 181, 169, 0.6)" // Dark green shadow effect
  }

  const exploreHead = {
    padding: vMediaQuery ? "0px" : "20px 90px 20px 60px"
  }
  return (
    <>
      <Box sx={{ flexGrow: 1, padding: vMediaQuery ? "30px 20px" : "50px 80px", }}>
        <Card className='cards' style={ExploreStyle}>
          <CardContent>
            <Grid container spacing={vMediaQuery ? 2 : 0}>
              <Grid item xs={12} md={5} lg={5}>
                <div className="headImg-contanier">
                  <img className="headimg" alt="explore" src={explore} />
                </div>
              </Grid>
              <Grid item xs={12} md={7} lg={7} sx={exploreHead} >
                <h1 className='heading'>Explore new possibilities with GDR  <br />  Consultancy - Leading Microsoft<br /> Dynamics 365</h1>
                <ComTypography variant={"body1"} text={"GDR Consultancy believes in creating tangible value for clients. Through our iterative approach and client-side experience we drive ERP implementation and Cloud migration projects ahead. Our flexible engagement models fit the business goals, resources, and timelines of enterprises, SMEs, and startups."} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>

      <MicrosoftCycle />
      <Client />
      <ControlCost />
      <CrmApp />
      <ErpApp />
      <CrmErp />
      <HelptoTalk />
    </>
  )
}

export default Explore;